export class NavegarValidacao {
    public idInscricao: number;
    public posicao: number;
}
